export function CATCH_ASYNC<T>(p: Promise<T>): Promise<T> {
  p.catch((e) => {
    console.error('CATCH_ASYNC ', e)
  })
  return p
}
